<script>
import CandelaControl from '@/components/controls/CandelaControl'

export default {
  extends: CandelaControl,
  computed: {
    selected_str() {
      return this.value && this.value.length ? this.value.length : 0
    }
  },
  name: 'candela-list',
  props: {
    color: {type: String, default: () => 'primary'},
    items: {type: Array, default: () => []},
    min: {type: Number, default: () => 1},
    max: {type: Number, default: () => Infinity},
    multiple: {type: Boolean, default: () => false},
    mandatory: {type: Boolean, default: () => false}
  }
}
</script>

<template>
<div class='candela-list-container d-flex flex-column ma-0 pa-0'>
  <div class='candela-list-control d-flex'>
    <v-list class='candela-list flex-grow-1' dense>
      <v-list-item-group v-model='value' :max='max'
        :multiple='multiple' :mandatory='mandatory' :color='color'>
        <v-list-item v-for='(item, i) in items' :key='`list-item-${i}`'
          :ripple='false'>
          {{item.text}}
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
  <div v-if='multiple' class='d-flex justify-end pt-1 select-count'>
    {{`${selected_str} of ${items.length} Selected`}}
  </div>
</div>
</template>

<style lang='sass' scoped>
@import '@/styles/variables'
.candela-list-container
  height: 100%
  max-height: 100%
  overflow: hidden
  padding: 0 !important
  margin: 0 !important
  border: none !important

.candela-list-control
  border-radius: $border-radius-root
  height: 100%
  overflow: scroll

.theme--dark
  .candela-list-control
    background-color: #1f1f1f
    border: 1px solid var(--v-grey-darken6)
  .select-count
    background: #1f1f1f

.theme--light
  .candela-list-control
    background-color: white
    border: 1px solid var(--v-grey-lighten6)
  .select-count
    background: white
</style>
